import { useCallback } from "react";

import { Stack } from "types/generated";
import { AccountContext } from "views/AccountWrapper";
import useTypedContext from "hooks/useTypedContext";

import useHasStackWriteAccess from "./useHasStackWriteAccess";

/**
 * Check if the current user can create tasks on the stack
 */
const useCanCreateTask = (): ((stack?: Stack) => boolean) => {
  const hasStackWriteAccess = useHasStackWriteAccess();
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (stack?: Stack) => {
      if (!stack) {
        return false;
      }

      if (stack.isDisabled) {
        return false;
      }

      if (stack.lockedBy) {
        return viewer.id === stack.lockedBy && hasStackWriteAccess(stack);
      }

      return hasStackWriteAccess(stack);
    },
    [hasStackWriteAccess, viewer?.id]
  );
};

export default useCanCreateTask;
